import { render, staticRenderFns } from "./create-outairthreshold.vue?vue&type=template&id=6e966522&"
import script from "./create-outairthreshold.vue?vue&type=script&lang=ts&"
export * from "./create-outairthreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports